<template>
  <div class="audio-wrap">
    <ul class="audio-list">
      <li
        v-for="(audio, index) in audios"
        :key="index"
        class="audio-list__item"
      >
        <a :href="audio.url" target="_blank" class="audio-list__link" rel="noreferrer">
          <i class="el-icon-video-play"></i> {{audio.title}}
        </a>
      </li>
    </ul>

  </div>
</template>

<script>
  export default {
    name: 'AudioGallery',
    props: {
      audios: {
        type: Array
      }
    },
  };
</script>

<style>
  .audio-wrap {
    background-color: #F5F7FA;
    margin-left: -20px;
    margin-bottom: -20px;
    margin-top: 20px;
    width: 770px;
    box-sizing: border-box;
    /*padding: 15px 20px 10px 73px;*/
    padding: 10px 0;
  }
  .audio-list {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
  }
  .audio-list__item {
    margin-right: 5px;
    width: 100px;
  }
  .audio-list__link,
  .audio-list__link:hover,
  .audio-list__link:visited,
  .audio-list__link:active {
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    color: #5E6D82;
    text-decoration: none;
  }
  .audio-list__link:hover {
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    color: #000000;
    text-decoration: none;
  }
</style>
